<script lang="ts">
  import { page } from '$app/stores';

  import { cn } from '@shared/utils';

  import { navigationLinksStore } from '@features/navigation';
  import { navigationLibs } from '@features/navigation';

  import { mobileMenuActivity } from '../models';

  $: auctionsCount = $page.data.institutionAuctionsCount;
  $: artistsCount = $page.data.institutionArtistsCount;
  $: artworksCount = $page.data.institutionArtworksCount;
  $: newsCount = $page.data.institutionNewsCount;
  $: curatorsCount = $page.data.institutionCuratorsCount;
  $: selectionsCount = $page.data.institutionSelectionsCount;

  $: linkWithCount = {
    [navigationLibs.NavigationTitle.Auctions]: auctionsCount,
    [navigationLibs.NavigationTitle.Artists]: artistsCount,
    [navigationLibs.NavigationTitle.Artworks]: artworksCount,
    [navigationLibs.NavigationTitle.Selections]: selectionsCount,
    [navigationLibs.NavigationTitle.News]: newsCount,
    [navigationLibs.NavigationTitle.Curators]: curatorsCount,
  } as Partial<Record<navigationLibs.NavigationTitle, number>>;
</script>

<ul class="flex w-full grow flex-col justify-center overflow-auto pt-20">
  {#each $navigationLinksStore as { link, title }, index}
    <li
      class="{cn('mb-1 overflow-hidden', {
        'mb-0': index === $navigationLinksStore.length - 1,
      })}"
    >
      <div
        class="transition-transform duration-300"
        class:-translate-y-full="{!$mobileMenuActivity}"
        style="transition-delay: {$mobileMenuActivity ? 500 + index * 100 : 300 - index * 50}ms"
      >
        <a href="/{link}/" class="text-5xl font-medium" on:click="{() => mobileMenuActivity.toggle()}">
          {title}
        </a>

        {#if title in linkWithCount}
          <span class="align-top text-sm font-medium">{linkWithCount[title]}</span>
        {/if}
      </div>
    </li>
  {/each}
</ul>
